import request from '@/utils/request'


// 查询产品规格组合列表
export function listGoodsCombination(query) {
  return request({
    url: '/user/goods-combination/list',
    method: 'get',
    params: query
  })
}

// 查询产品规格组合分页
export function pageGoodsCombination(query) {
  return request({
    url: '/user/goods-combination/page',
    method: 'get',
    params: query
  })
}

// 查询产品规格组合详细
export function getGoodsCombination(data) {
  return request({
    url: '/user/goods-combination/detail',
    method: 'get',
    params: data
  })
}

// 新增产品规格组合
export function addGoodsCombination(data) {
  return request({
    url: '/user/goods-combination/add',
    method: 'post',
    data: data
  })
}

// 修改产品规格组合
export function updateGoodsCombination(data) {
  return request({
    url: '/user/goods-combination/edit',
    method: 'post',
    data: data
  })
}

// 删除产品规格组合
export function delGoodsCombination(data) {
  return request({
    url: '/user/goods-combination/delete',
    method: 'post',
    data: data
  })
}

// 获取商品下的产品组合下拉选项（zb_goods_spec_combination + zb_spec_option.name）
export function listGoodsSpecCombinationOptions(query) {
  return request({
    url: '/user/goods-combination/spec-combination-options',
    method: 'get',
    params: query
  })
}
